import Bugsnag from "@bugsnag/js"
import { default as initCommonDataStore } from "../../../../lib/common/js/dataStore"
import { initAnswersUtils } from "./answersUtils"

function getInitialValues() {
  return {
    // Globals
    usePaymentsApi: true,
    token: null,
    measurementSystem: pipelineConfig.measurementSystem,
    domain: null,
    activeOffer: null,
    marketingAgreed: null,
    privacyAgreement: false,
    purchasedBasicOffer: null,
    skippedUpsellOffers: [],
    checkout: null,
    initiateCheckoutAt: null,
    isEmailStepCompleted: false,
    exitIntent: false,
    isExitIntentPopupShown: false,
    isPaymentLoading: false,
    segmentUserId: null,
    cookiePolicyBannerAccepted: null,

    // Specific values for the series
    goalPaceKg: 2,
    goalPaceLbs: 4,

    // Pipe form
    gender: null,
    ageRange: null,
    yourGoal: null,
    familiarWithDiet: null,
    whenFeelHungry: [],
    mealOfTheDay: null,
    lostWeightButFailed: null,
    heightFt: null,
    heightIn: null,
    heightCm: null,
    weightKg: null,
    weightLbs: null,
    targetWeightKg: null,
    targetWeightLbs: null,
    firstName: null,
    physicallyActive: null,
    howLongSinceIdealWeight: null,
    clothesSize: null,
    clothesSizeGoal: null,
    eatingHabits: null,
    favIngredients: [],
    preferredProtein: [],
    foodAllergies: [],
    sleep: null,
    glassesOfWater: null,
    workingHours: null,
    describeDay: null,
    medication: [],
    diseases: [],
    additionalGoal: [],
    email: null,
    nutritionistChatAnswers: [],
  }
}

// Define data values to be used in this specific pipe variation
// and feed them to the basic data store creator fn, which is placed
// in the `lib` under current pipe series folder.
const dataStore = {
  ...initCommonDataStore({
    getInitialValues,
  }),

  // All variation-specific props and methods can de added or overwritten below:
  // isMetric() { },
}

// Series-specific namespaced helpers for conditional
// UI rendering based on previous answers.
// Why not initiated in common: we can't guarantee that
// different series will have same data values names and logic
dataStore.answersUtils = initAnswersUtils(dataStore)

export default dataStore
